export default __webpack_public_path__ + "media/images/user_photos/32-37cfd506926ea9916d5f36fbd961daa4.jpg";